import type { Route } from './types';

export const PROFILE_ROUTES: Record<string, Route> = {
  MY_PARTNER: {
    PATH: '/profile/my-partner',
    NAME: 'my-partner',
  },
};
